import Schema from 'validate';
import isEmail from 'validator/lib/isEmail';

import orgaSchema from '../../../../../lib/paths/organisation_FULL_Paths.json';
const P = orgaSchema.attributes;

const mailValidator = (val: string) => isEmail(val);

const OrganisationDataValidator = new Schema({
	[P.Geschaeftsbezogene_Daten_Name_Der_Organisation.path]: {
		type: String,
		required: true,
	},
	[P.Geschaeftsbezogene_Daten_Kuerzel.path]: {
		type: String,
		required: true,
	},
	[P.Adressdaten_Strasse_Und_Hausnummer.path]: {
		type: String,
		required: true,
	},
	[P.Adressdaten_Adresszusatz.path]: {
		type: String,
	},
	[P.Adressdaten_Bezeichnung.path]: {
		type: String,
	},
	[P.Adressdaten_PLZ.path]: {
		type: String,
		required: true,
	},
	[P.Adressdaten_Ort.path]: {
		type: String,
		required: true,
	},
	[P.Kontaktdaten_E_Mail.path]: {
		type: String,
		required: true,
		use: { mailValidator },
		message: {
			mailValidator: 'Ungültige E-Mail-Adresse.',
		},
	},
	[P.Kontaktdaten_Fax.path]: {
		type: String,
	},
	[P.Kontaktdaten_Telefon.path]: {
		type: String,
		required: true,
		use: {
			phone: (val: string) => /^[0-9\s]*$/.test(val),
		},
		message: {
			phone: 'Diese Telefonnummer ist ungültig. Es sind nur Zahlen und Leerzeichen erlaubt.',
		},
	},
	[P.Kontaktdaten_Webadresse.path]: {
		type: String,
	},
});

OrganisationDataValidator.message({
	required: (_path: string) => 'Dies ist ein Pflichtfeld.',
	type: (path: string) =>
		`Das Formular ist fehlerhaft, bitte melden Sie diesen Fehler. Geben Sie als Grund "falscher Datentyp, ${path}" an.`,
});

export default OrganisationDataValidator;
